import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ConfigService } from 'ngx-envconfig';
@Injectable({
  providedIn: "root"
})
export class TokenService {
  private iss = {
    login: ""
  };

  constructor(public router: Router, private configService: ConfigService) {
    this.iss.login = `${configService.get('HOST')}`
  }

  handle(token) {
    this.setToken(token);
  }

  setToken(token) {
    localStorage.setItem("token", token);
  }

  getToken() {
    return localStorage.getItem("token");
  }

  getLogin() {
    const token = this.getToken();
    const payload = this.payload(token);
    return payload.unique_name;
  }

  removeToken() {
    localStorage.removeItem("token");
  }

  isValid() {
    const token = this.getToken();
    if (token) {
      const payload = this.payload(token);
      if (payload) {
        return Object.values(this.iss).indexOf(payload.iss) > -1 ? true : false;
      }
    }
    return false;
  }

  payload(token) {
    const payload = token.split(".")[1];
    return this.decode(payload);
  }

  decode(payload) {
    return JSON.parse(atob(payload));
  }

  loggedIn() {
    if (this.isValid()) {
      return true;
    } else {
      this.router.navigate(["/login"]);
      return false;
    }
  }

  getTokenExpirationDate(): Date {
    const token = this.getToken();
    const payload = this.payload(token);
    const expiration = payload.exp;

    if (expiration === undefined) return null;

    const date = new Date(0);
    date.setUTCSeconds(expiration);
    return date;
  }

  isTokenExpired(): boolean {
    const date = this.getTokenExpirationDate();
    if (date === undefined) return false;
    return !(date.valueOf() > new Date().valueOf());
  }
}
